export const LLAMADA_MASIVA_ADUANA_ANULAR_LOTE_BASE = {
  accion: 'py_febos_core',
  nombre: 'Anular Lotes',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.lotes._id.acciones.Handler',
    pais: 'cl',
    accion: 'anular',
    body: {
      mensaje: undefined
    }
  },
  payload: [
    {
      lote_id: undefined
    }
  ]
};

export const LLAMADA_MASIVA_ADUANA_RECHAZAR_LOTE_BASE = {
  accion: 'py_febos_core',
  nombre: 'Rechazar Lotes',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.lotes._id.acciones.Handler',
    pais: 'cl',
    accion: 'rechazar',
    body: {
      mensaje: undefined
    }
  },
  payload: [
    {
      lote_id: undefined
    }
  ]
};

export const LLAMADA_MASIVA_ADUANA_APROBAR_LOTE_BASE = {
  accion: 'py_febos_core',
  nombre: 'Aprobar Lotes',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.lotes._id.acciones.Handler',
    pais: 'cl',
    accion: 'aprobar',
  },
  payload: [
    {
      lote_id: undefined
    }
  ]
};

export const LLAMADA_MASIVA_ADUANA_VALIDAR_LOTE_BASE = {
  accion: 'py_febos_core',
  nombre: 'Validar Lotes',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.lotes._id.acciones.Handler',
    pais: 'cl',
    accion: 'validar'
  },
  payload: [
    {
      lote_id: undefined
    }
  ]
};

export const LLAMADA_MASIVA_ADUANA_FACTURAR_COMPROBANTE_BASE = {
  accion: 'py_febos_core',
  nombre: 'Facturar Comprobantes',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.comprobantes._id.facturar.Handler',
    pais: 'cl',
    accion: 'facturar',
  },
  payload: [
    {
      comprobante_id: undefined
    }
  ]
};

export const LLAMADA_MASIVA_ADUANA_CANCELAR_SUBASTA_BASE = {
  accion: 'py_febos_core',
  nombre: 'Cancelar subasta',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.subastas._id.acciones.Handler',
    pais: 'cl',
    accion: 'cancelar',
    body: {
      mensaje: undefined
    }
  },
  payload: [
    {
      id: undefined
    }
  ]
};

export const LLAMADA_MASIVA_ADUANA_PREPARAR_SUBASTA_BASE = {
  accion: 'py_febos_core',
  nombre: 'Preparar subasta',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.subastas._id.acciones.Handler',
    pais: 'cl',
    accion: 'preparar',
    body: {
      mensaje: undefined
    }
  },
  payload: [
    {
      id: undefined
    }
  ]
};
export const LLAMADA_MASIVA_ADUANA_DES_PREPARAR_SUBASTA_BASE = {
  accion: 'py_febos_core',
  nombre: 'Dejar de Preparar subasta',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.subastas._id.acciones.Handler',
    pais: 'cl',
    accion: 'des-preparar',
    body: {
      mensaje: undefined
    }
  },
  payload: [
    {
      id: undefined
    }
  ]
};
export const LLAMADA_MASIVA_ADUANA_PUBLICAR_SUBASTA_BASE = {
  accion: 'py_febos_core',
  nombre: 'Publicar subasta',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.subastas._id.acciones.Handler',
    pais: 'cl',
    accion: 'publicar',
    body: {
      mensaje: undefined
    }
  },
  payload: [
    {
      id: undefined
    }
  ]
};
export const LLAMADA_MASIVA_ADUANA_FINALIZAR_SUBASTA_BASE = {
  accion: 'py_febos_core',
  nombre: 'Finalizar subasta',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.subastas._id.acciones.Handler',
    pais: 'cl',
    accion: 'finalizar',
    body: {
      mensaje: undefined
    }
  },
  payload: [
    {
      id: undefined
    }
  ]
};
export const LLAMADA_MASIVA_ADUANA_DONAR_LOTE_BASE = {
  accion: 'py_febos_core',
  nombre: 'Donar lote',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.lotes._id.acciones.Handler',
    pais: 'cl',
    accion: 'donar',
    body: {
      mensaje: undefined
    }
  },
  payload: [
    {
      lote_id: undefined
    }
  ]
};
export const LLAMADA_MASIVA_ADUANA_DESTRUIR_LOTE_BASE = {
  accion: 'py_febos_core',
  nombre: 'Destruir lote',
  comunes: {
    handler: 'funcion_lambda.febos.funciones.aduanas.lotes._id.acciones.Handler',
    pais: 'cl',
    accion: 'destruir',
    body: {
      mensaje: undefined
    }
  },
  payload: [
    {
      lote_id: undefined
    }
  ]
};
